export class Country {
	constructor(data) {
		this.name = data && data.name ? data.name : "";
		this.code = data && data.code ? data.code : "";
		this.connect_available = data && data.connect_available ? data.connect_available : false;
	}
}